class GenericCompany {
    id;
    tags;
    constructor(response) {
        this.id = response?.id;
        this.tags = response?.tags !== undefined ? response.tags : undefined;
    }
}
export default GenericCompany;
